const value = {
    pageTitle: 'Unit creation',
    stepSettings: 'Settings',
    stepTheory: 'Theory',
    stepTest: 'Quiz',
    stepPractice: 'Practice',
    stepResult: 'Results',
    newUnit: 'New unit',
    taskOne: 'Task 1',
    task: 'Task',
    codeReview: 'Code review',
    chapterNumber: 'Chapter {{number}}',
    clearChapter: 'Clear chapter',
    addingInfo: 'Double-click or drag a component to add it',
    chapters: 'Chapters',
    text: 'Text',
    heading1: 'Title 1',
    heading2: 'Title 2',
    heading3: 'Title 3',
    p: 'Paragraph',
    list: 'List',
    listNumeric: 'Numbered',
    listBullet: 'Bulleted',
    table: 'Table',
    columns: 'Columns',
    rows: 'Rows',
    tableTitle: 'Table header',
    cellText: 'Cell text',
    media: 'Media',
    img: 'Image',
    video: 'Video',
    codeExample: 'Code example',
    codeLang: 'Language',
    spacing: 'Spacing',
    spacingSize: 'Spacing {{size}}',
    nesting: 'Nesting',
    hiddenBlock: 'Hidden block',
    tabs: 'Tabs',
    tabCount: 'Tab {{count}}',
    tags: 'Tags',
    tagCount: 'Tag {{count}}',
    specialBlock: 'Special block',
    chapterName: 'Name of chapter',
    title: 'Title',
    link: 'Link',
    linkHelper: 'Specify the full path to the file with the extension. Example: http://domain/video.mp4',
    linkExtsError: 'The link must contain the full path to the file, including the extensions .mp4/webm/ogg',
    file: 'File',
    color: 'Color',
    colorNameWarning: 'Warning',
    colorNameSecondary: 'Definition',
    colorNameMain: 'Table',
    colorNameSuccess: 'Encouragement',
    colorNameError: 'Error',
    colorNameInfo: 'Information',
    quantity: 'Number',
  };

export default value;
